export const ORDER_QUANTITY_MIN_ERROR =
  'Quantity must be a whole number greater than 0';

export const parseOrderLineQuantity = (value) => {
  if (value === '' || value === null || value === undefined) return null;
  const parsed = Number(value);
  if (!Number.isInteger(parsed)) return null;
  return parsed;
};

export const isValidOrderLineQuantity = (qty) => {
  const parsed = parseOrderLineQuantity(qty);
  return parsed !== null && parsed > 0;
};

export const getOrderQuantityValidationError = (orders) => {
  if (!orders?.length) return ORDER_QUANTITY_MIN_ERROR;
  if (orders.some((order) => !isValidOrderLineQuantity(order.quantity))) {
    return ORDER_QUANTITY_MIN_ERROR;
  }
  return null;
};
